import React from 'react'
import VBEvents from '../components/VBEvents'

const StatsHome = () => {
  return <VBEvents />
}

export default StatsHome
